import React, { useEffect } from 'react';

interface IntelligentAnalysisReportsProps {
  onOpenRightSidebar?: () => void;
}

const IntelligentAnalysisReports: React.FC<IntelligentAnalysisReportsProps> = ({ onOpenRightSidebar }) => {
  useEffect(() => {
    // Automatically open the right sidebar when this component mounts
    if (onOpenRightSidebar) {
      onOpenRightSidebar();
    }
  }, [onOpenRightSidebar]);

  // Return null to render nothing in the main content area
  return null;
};

export default IntelligentAnalysisReports;
